import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../api";
import { useTheme } from "../../components/header/header";
import "./personal-information.css";

import Input from "../../components/input/input";
import Button from "../../components/button/button";

import back from "./img/back.svg";
import backDark from "./img/back-dark.svg";

const PersonalInfo = () => {
  const { theme } = useTheme();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [initialData, setInitialData] = useState(null);
  const [error, setError] = useState("");
  const [buttonText, setButtonText] = useState("Save Changes");

  useEffect(() => {
    const hasReloaded = localStorage.getItem("hasReloaded");

    if (!hasReloaded) {
      window.location.reload();
      localStorage.setItem("hasReloaded", "true");
    }

    return () => {
      localStorage.removeItem("hasReloaded");
    };
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await api.get("/api/user", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const userData = {
          email: response.data.email,
          phone_number: response.data.phone_number,
          user_name: response.data.user_name,
        };

        setEmail(response.data.email);
        setPhone(response.data.phone_number);
        setUserName(response.data.user_name);

        setInitialData(userData);
      } catch (err) {
        if (err.response) {
          setError(err.response.data.error.message);
        } else {
          setError("An error occurred while fetching user data.");
        }
      }
    };

    fetchUserData();
  }, []);

  const validateEmail = (val) => {
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
    if (!emailPattern.test(val)) {
      return "Please enter a valid email address.";
    }
    return null;
  };

  const validatePassword = (val, initialPassword) => {
    if (!val.trim() && !initialPassword) return null;

    if (val.length < 6) {
      return "Password must be at least 6 characters long.";
    }
    return null;
  };

  const validatePhone = (val, initialPhone) => {
    if (!val.trim() && !initialPhone) return null;

    const phonePattern = /^\+?\d{10,15}$/;
    if (!phonePattern.test(val)) {
      return "Please enter a valid phone number.";
    }
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;

    if (validateEmail(email)) {
      isValid = false;
    }
    if (validatePassword(password, initialData?.password)) {
      isValid = false;
    }
    if (validatePhone(phone, initialData?.phone_number)) {
      isValid = false;
    }

    if (!isValid) {
      setError("Something went wrong");
      return;
    }

    setError(null);

    try {
      const token = localStorage.getItem("token");
      const response = await api.put(
        "/api/user",
        {
          email,
          phone_number: phone,
          password,
          user_name: userName,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setInitialData({
        email,
        phone_number: phone,
        user_name: userName,
      });

      console.log(response.data.message);

      setButtonText("Saved");
      setTimeout(() => {
        setButtonText("Save Changes");
      }, 3000);

      setError("");
    } catch (err) {
      if (err.response) {
        setError(err.response.data.error.message);
      } else {
        setError("An error occurred while updating user data.");
      }
      setButtonText("Save Changes");
    }
  };

  const hasChanges = () => {
    if (!initialData) return false;

    return (
      email !== initialData.email ||
      phone !== initialData.phone_number ||
      userName !== initialData.user_name ||
      (password && password !== initialData.password)
    );
  };

  const updateButtonState = () => {
    if (!hasChanges()) {
      setButtonText("Save Changes");
    }
  };

  return (
    <>
      <div className="headerPayment">
        <Link className="backBtn" to={"/deposit"}>
          <img src={theme === "light" ? back : backDark} alt="back" />
        </Link>
        <div className="title">Personal Information</div>
      </div>
      <div className="container">
        <div className="personalInfo">
          <form className="personalInfoForm">
            <div>
              <Input
                label="Name"
                id="name"
                value={userName}
                onChange={(val) => {
                  setUserName(val);
                  updateButtonState();
                }}
              />
              <Input
                label="Email address"
                id="email"
                value={email}
                onChange={(val) => {
                  setEmail(val);
                  updateButtonState();
                }}
                validate={(val) => validateEmail(val)}
              />
              <Input
                label="Phone number"
                id="phone"
                value={phone}
                onChange={(val) => {
                  setPhone(val);
                  updateButtonState();
                }}
                validate={(val) => validatePhone(val, initialData?.phone_number)}
                optional
              />
              <Input
                label="Password"
                id="password"
                type="password"
                onChange={(val) => {
                  setPassword(val);
                  updateButtonState();
                }}
                validate={(val) => validatePassword(val, initialData?.password)}
                optional
              />
            </div>
            <div>
              <Button
                onClick={handleSubmit}
                text={buttonText}
                disabled={!hasChanges()}
              />
              {error && <div className="error">{error}</div>}
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PersonalInfo;
